/**
 * The sheets that open by themselves: one per session, and the kids and refer
 * sheets at least GAP_DAYS apart. Priority is sign-in > kids > refer:
 *   - sign-in is for guests only, so it never meets the other two; it takes
 *     the session but not the gap (a heart tap opens it, and that is a reply);
 *   - refer stands down while the kids nudge is due (snippets/includ-refer-sheet.liquid).
 * Sheets a shopper opens on purpose (size chart, How it works, Add a kid) are
 * not gated. Storage that can't be read or written means the limits can't be
 * kept, so nothing opens.
 *
 * Also the refer sheet's rules and the "has this shopper ever referred" read,
 * shared with the INCLUD Cash card on the product page.
 * Plain script (no imports) so tests/includ-sheets.test.mjs can load it as is.
 */
(function () {
  var GAP_DAYS = 3;
  var GAP_MS = GAP_DAYS * 24 * 60 * 60 * 1000;
  var SESSION_KEY = 'includ-sheet-shown';
  var LAST_KEY = 'includ-sheet-last'; /* ms of the last kids / refer sheet on this device */
  var REFER_TEMPLATES = ['index', 'collection', 'product'];
  var REFER_MAX_TIMES = 3;
  var REFERRED_KEY = 'includ-referred'; /* localStorage '1': has referred, for good */
  var NOT_REFERRED_KEY = 'includ-not-referred'; /* localStorage ms: last read that found none */
  var NOT_REFERRED_MS = 24 * 60 * 60 * 1000;
  var LEDGER_URL = '/apps/asp/asp-shopify-service/v1/customer/rewards-ledger?page=0&size=100';

  /* withGap: the kids and refer sheets; the sign-in sheet passes false. */
  function due(withGap, now) {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return false;
      if (!withGap) return true;
      return (now || Date.now()) - (Number(localStorage.getItem(LAST_KEY)) || 0) >= GAP_MS;
    } catch (e) { return false; }
  }

  /* Call right before showing; false = don't show. */
  function claim(withGap, now) {
    if (!due(withGap, now)) return false;
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
      if (withGap) localStorage.setItem(LAST_KEY, String(now || Date.now()));
      return true;
    } catch (e) { return false; }
  }

  /* Referral credits are the only ledger lines that say "refer" (pmsdb, 26 Oct 2026:
     "Referral Reward – …" for REFEREE_SIGNUP, "… by your referee …" for
     REFEREE_ORDER_PLACED). The storefront ledger has no source type, so the
     wording is the only signal: if the backend rewords these, this goes false. */
  function hasReferral(rows) {
    return rows.some(function (r) {
      return String(r && r.direction).toUpperCase() === 'CREDIT' && /refer/i.test(String(r && r.uiComment));
    });
  }

  /* Promise<true | false | null>; null = couldn't tell (treat as don't show).
     A "no" is kept for a day, a "yes" for good. Not per session: the app opens
     each product page in a new screen with its own sessionStorage, so a
     session cache would read the ledger on every product page.
     ponytail: the newest 100 lines only; a referral older than that reads as none. */
  var pending = null; /* the refer sheet and the PDP card ask on the same page */
  function referred(doFetch, now) {
    if (pending) return pending;
    now = now || Date.now();
    try {
      if (localStorage.getItem(REFERRED_KEY)) return Promise.resolve(true);
      if (now - (Number(localStorage.getItem(NOT_REFERRED_KEY)) || 0) < NOT_REFERRED_MS) return Promise.resolve(false);
    } catch (e) { return Promise.resolve(null); }
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 5000);
    pending = (doFetch || window.fetch.bind(window))(LEDGER_URL, {
      cache: 'no-store', headers: { Accept: 'application/json' }, signal: ctrl.signal
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var rows = j && j.successful !== false && j.result && j.result.content;
        if (!Array.isArray(rows)) return null;
        var yes = hasReferral(rows);
        try { localStorage.setItem(yes ? REFERRED_KEY : NOT_REFERRED_KEY, yes ? '1' : String(now)); } catch (e) { return null; }
        return yes;
      })
      .catch(function () { return null; })
      .finally(function () { clearTimeout(timer); pending = null; });
    return pending;
  }

  /* Everything but "has referred", which needs the network. */
  function shouldRefer(s) {
    return !!(s.isApp && s.signedIn && s.rewardsOn && REFER_TEMPLATES.indexOf(s.template) >= 0 &&
      s.timesShown < REFER_MAX_TIMES && s.sheetDue && !s.kidsDue && !s.sheetOpen);
  }

  window.IncludSheets = Object.freeze({
    due: due, claim: claim, hasReferral: hasReferral, referred: referred, shouldRefer: shouldRefer
  });
})();
